import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useIntl, FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import FlexColumn from '../../shared/components/layouts/FlexColumn'
import FormikTextField from '../../shared/components/formik/FormikTextField'
import { useAuthentication } from '../../contexts/AuthenticationContext'

const LoginCredentialsForm = ({ onResult }) => {
  const intl = useIntl()
  const { login } = useAuthentication()

  const validationSchema = Yup.object({
    email: Yup.string()
      .email(intl.formatMessage({ id: 'login.error.invalidEmail' }))
      .required(intl.formatMessage({ id: 'login.error.required' })),
    password: Yup.string()
      .min(6, intl.formatMessage({ id: 'login.error.passwordMin' }))
      .required(intl.formatMessage({ id: 'login.error.required' })),
  })

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      setStatus(null)
      login(values.email, values.password)
        .then((result) => {
          onResult(result)
        })
        .catch(() => {
          setStatus(intl.formatMessage({ id: 'login.error.invalidCredentials' }))
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
  })

  return (
    <FlexColumn gap={2}>
      {formik.status && (
        <Alert severity="error">{formik.status}</Alert>
      )}

      <Box component="form" onSubmit={formik.handleSubmit} sx={{ width: '100%' }}>
        <FlexColumn gap={2}>
          <FormikTextField
            formik={formik}
            name="email"
            label={<FormattedMessage id="login.email" />}
            type="email"
            autoComplete="email"
            autoFocus
          />

          <FormikTextField
            formik={formik}
            name="password"
            label={<FormattedMessage id="login.password" />}
            type="password"
            autoComplete="current-password"
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={formik.isSubmitting}
          >
            <FormattedMessage id="login.submit" />
          </Button>
        </FlexColumn>
      </Box>
    </FlexColumn>
  )
}

export default LoginCredentialsForm
